import mitt, { Emitter, Handler } from "mitt";

type SessionHandlerEvent = "onExpired" | "onAuthenticated";

export default class SessionHandler {
	private eventHandler: Emitter<{ onAuthenticated: void; onExpired: void }> = mitt();

	authenticated() {
		this.eventHandler.emit("onAuthenticated");
	}

	async expired(callback?: () => void, type?: "RequireTwoFactor"): Promise<void> {
		try {
			let authPromise = new Promise<void>((resolve) => {
				let eventHandler = () => {
					this.eventHandler.off("onAuthenticated", eventHandler);
					callback?.();
					resolve();
				};

				this.eventHandler.on("onAuthenticated", eventHandler);
			});

			let dialog: HTMLDialogElement | null = document.querySelector("dialog.session-expired-dialog");
			if (!dialog) {
				dialog = document.createElement("dialog");
				dialog.className = "session-expired-dialog";
				dialog.style.display = "flex";
				dialog.style.padding = "0";
				dialog.style.left = "50%";
				dialog.style.transform = "translateX(-50%)";

				let link = "/login?ReturnUrl=%2fapi/sessionexpired/remove";
				if (type !== "RequireTwoFactor") {
					await fetch("/logout", { method: "POST" });
				} else {
					link = "/login?RequireTwoFactor=1&ReturnUrl=%2fapi/sessionexpired/remove";
				}

				dialog.innerHTML = `<iframe sandbox="allow-same-origin allow-scripts allow-modals allow-top-navigation-by-user-activation allow-forms" src="${link}" style="border:0;width:min(500px,100vw);height:min(700px, 100vh);"></iframe>`;
				document.body.append(dialog);
				dialog.showModal();
				await authPromise;
				dialog.remove();
			} else {
				await authPromise;
			}
		} catch (_) {
			window.location.href = `/login?ReturnUrl=${encodeURIComponent(window.location.pathname)}${encodeURIComponent(
				window.location.search,
			)}`;
		}
	}

	attachEvent(eventName: SessionHandlerEvent, handler: Handler) {
		return this.eventHandler.on(eventName, handler);
	}

	detachEvent(eventName: SessionHandlerEvent, handler: Handler) {
		return this.eventHandler.off(eventName, handler);
	}
}
